(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[602],{

/***/ 26:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/error",
      function () {
        return __webpack_require__(8086);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _header_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5647);
/* harmony import */ var _footer_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8050);




function Layout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        className: "page-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_header_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "header-not-transparent"
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_footer_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 8050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js + 4 modules
var index_esm = __webpack_require__(7219);
;// CONCATENATED MODULE: ./src/common/Blury.tsx


var Blury = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rn-gradient-circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rn-gradient-circle theme-pink"
            })
        ]
    });
};
/* harmony default export */ var common_Blury = (Blury);

;// CONCATENATED MODULE: ./src/common/footer/ScrollTop.tsx




function ScrollTop() {
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var toggleVisible = function() {
        var scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true);
        } else if (scrolled <= 300) {
            setVisible(false);
        }
    };
    var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", toggleVisible);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rn-back-top",
                onClick: scrollToTop,
                style: {
                    display: visible ? "inline" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronUp */.rH8, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Blury, {})
        ]
    });
}
/* harmony default export */ var footer_ScrollTop = (ScrollTop);

;// CONCATENATED MODULE: ./src/common/footer/Footer.tsx




var linkItemSections = [
    {
        id: 4,
        title: "Company",
        quicklink: [
            {
                id: 1,
                text: "About",
                url: "/about-us"
            }, 
        ]
    }, 
];
function FooterLinkItem(param) {
    var url = param.url, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: text
            })
        })
    }, url);
}
function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: "rn-footer footer-style-default no-border",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "footer-top",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: linkItemSections.map(function(section) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-2 col-md-6 col-sm-6 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "rn-footer-widget",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "title",
                                                    children: section.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "inner",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "footer-link link-hover",
                                                        children: section.quicklink.map(function(data) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinkItem, {
                                                                url: data.url,
                                                                text: data.text
                                                            }, data.id);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }, section.id);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "copyright-area copyright-style-one no-border",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-sm-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "copyright-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "ft-menu link-hover",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/terms/privacy",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: "Privacy Policy"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/terms",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: "Terms And Condition"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/contact-us",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: "Contact Us"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 col-md-6 col-sm-12 col-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "copyright-right text-center text-md-end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "copyright-text",
                                                children: "\xa9 Modulabs 2022"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_ScrollTop, {})
        ]
    });
}
/* harmony default export */ var footer_Footer = (Footer);


/***/ }),

/***/ 5647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js + 4 modules
var index_esm = __webpack_require__(7219);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/logo/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.1f159720.png","height":1120,"width":3400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAACVBMVEX9/f38/Pz8/PwW5cCcAAAAA3RSTlMvHCL6cNm6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAFklEQVQImWNgZGBgYmRkYmRgZAADJgAAggAMQ8Ab2AAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/logo/logo-dark.png
/* harmony default export */ var logo_dark = ({"src":"/_next/static/media/logo-dark.2600f6a6.png","height":1120,"width":3400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEUTExMTExO++MG8AAAAAnRSTlMeLwkDz74AAAAJcEhZcwAACxMAAAsTAQCanBgAAAASSURBVAiZY2BgZGSAAEYwYAAAAEwACfmpKPMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/elements/logo/Logo.tsx






function Logo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "logo",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-fill logo-light",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "responsive",
                            src: logo,
                            alt: "Modulabs Logo",
                            placeholder: "blur",
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-fill logo-dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "responsive",
                            src: logo_dark,
                            alt: "Modulabs Logo",
                            placeholder: "blur",
                            priority: true
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var logo_Logo = (Logo);

;// CONCATENATED MODULE: ./src/common/header/Nav.tsx



function Nav() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "mainmenu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "has-droupdown",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: "Home"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/about-us",
                    children: "About"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "has-droupdown",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/contact-us",
                    children: "Contact"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/common/header/MobileMenu.tsx





function MobileMenu(param) {
    var show = param.show, onClose = param.onClose;
    (0,react.useEffect)(function() {
        var elements = document.querySelectorAll(".popup-mobile-menu .has-droupdown > a");
        var elementsTwo = document.querySelectorAll(".popup-mobile-menu .with-megamenu > a");
        for(var i in elements){
            if (elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector(".submenu").classList.toggle("active");
                    this.classList.toggle("open");
                };
            }
        }
        for(var prop in elementsTwo){
            if (elementsTwo.hasOwnProperty(prop)) {
                elementsTwo[prop].onclick = function() {
                    this.parentElement.querySelector(".rn-megamenu").classList.toggle("active");
                    this.classList.toggle("open");
                };
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "popup-mobile-menu ".concat(show ? "active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_Logo, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "close-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "close-button",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {})
            ]
        })
    });
}
/* harmony default export */ var header_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./src/common/header/DarkMode.tsx


function DarkMode() {
    var switchTheme = function() {
        document.querySelector("body").classList.toggle("light");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        id: "darkmode",
        onClick: switchTheme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "light-icon",
                src: "/images/icons/sun-01.svg",
                alt: "Sun images"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "dark-icon",
                src: "/images/icons/vector.svg",
                alt: "Sun images"
            })
        ]
    });
}
/* harmony default export */ var header_DarkMode = (DarkMode);

;// CONCATENATED MODULE: ./src/common/header/useStickyHeader.ts

var useStickyHeader = function() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var ref = (0,react.useState)(false), stick = ref[0], setStick = ref[1];
    var handleScroll = function() {
        setStick(window.scrollY > offset);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    });
    return stick;
};
/* harmony default export */ var header_useStickyHeader = (useStickyHeader);

;// CONCATENATED MODULE: ./src/common/header/Header.tsx








function Header(param) {
    var className = param.className;
    var ref = (0,react.useState)(false), offCanvasShow = ref[0], setOffCanvasShow = ref[1];
    var onCanvasHandler = function() {
        setOffCanvasShow(function(prev) {
            return !prev;
        });
    };
    var headerRef = (0,react.useRef)();
    var check = true;
    var sticky = header_useStickyHeader(50);
    var headerClasses = "header-default ".concat(sticky && check ? "sticky" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: headerRef,
                className: "rn-header header-default ".concat(className, " ").concat(headerClasses),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container position-relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center row--0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-3 col-md-6 col-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_Logo, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-9 col-md-6 col-8 position-static",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header-right",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                            className: "mainmenu-nav d-none d-lg-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-menu-bar ml--5 d-block d-lg-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hamberger",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "hamberger-button",
                                                    onClick: onCanvasHandler,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiMenu */.cur, {})
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header_DarkMode, {})
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_MobileMenu, {
                show: offCanvasShow,
                onClose: onCanvasHandler
            })
        ]
    });
}
/* harmony default export */ var header_Header = (Header);


/***/ }),

/***/ 8086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Error; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _common_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6461);





function Error() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Modulabs | Contact Submission Error"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "error-area ptb--200 ptb_sm--60 ptb_md--80",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row align-item-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-lg-12",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "error-inner",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: "500"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "title",
                                        children: "We were unable to accept your form please try again."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "view-more-button",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/contact-us",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "btn-default",
                                                children: "Go Back"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4,774,888,179], function() { return __webpack_exec__(26); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);